import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoadingController } from '@ionic/angular';
import { SharedService } from 'src/app/core-files/shared.service.';
import { AgentCallingService } from 'src/app/services/agent-calling.service';
import { SharedServices } from 'src/app/services/shared.service';
import { DialogInfoDetailsComponent } from '../dialog-info-details/dialog-info-details.component';

@Component({
  selector: 'app-import-calling-contact',
  templateUrl: './import-calling-contact.component.html',
  styleUrls: ['./import-calling-contact.component.scss'],
  standalone: false
})
export class ImportCallingContactComponent implements OnInit {
  selectedFile: File | null = null;
  selectedFileName: string = '';
  file: File | null = null;
  constructor(private sharedServices: SharedServices,
    private sharedService: SharedService,
    private loadingController: LoadingController,
    private matDialog: MatDialog,
    private agentCallingService: AgentCallingService,) { }

  ngOnInit() { }
  onFileSelected(event: any) {
    this.file = event.target.files[0];
    if (this.file) {
      this.selectedFile = this.file;
      this.selectedFileName = this.file.name;
      // this.uploadExcel();
    } else {
      this.selectedFileName = "";
    }
  }

  async uploadExcel() {
    if (!this.selectedFile) return;

    this.matDialog.closeAll();
    const loadingCtrl = this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    (await loadingCtrl).present();
    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    formData.append('MainAgentId', this.sharedServices.getAgentId());
    this.agentCallingService.ImportContactsFromExcel(formData).subscribe({
      next: async (res) => {
        // Handle success
        (await loadingCtrl).dismiss();
        this.sharedService.setCallingResponseSave(true);
       
        this.sharedServices.opneInfoDialog('Import Contact', 'Contacts imported successfully!');
         setTimeout(() => {
          this.matDialog.closeAll();
        }, 5000);
      },
      error: async (err) => {
        // Handle error
        (await loadingCtrl).dismiss();
      }
    });

  }
  cancel() {
    this.matDialog.closeAll();

  }
}
